<template>
  <div class="appConfiguration-container">
    <div class='config-content' v-if="userinfo.appCode">
        <div class='tabs'>
          <div :class="selectIndex === 0 ? 'tab-select' : 'tab-unselect'" @click="clickTbas(0)">
            Logo
          </div>
          <!-- <div :class="selectIndex === 1 ? 'tab-select' : 'tab-unselect'" @click="clickTbas(1)">
            电商中心
          </div> -->
          <div :class="selectIndex === 2 ? 'tab-select' : 'tab-unselect'" @click="clickTbas(2)">
            {{ $t('operate.name147') }}
          </div>
          <div :class="selectIndex === 3 ? 'tab-select' : 'tab-unselect'" @click="clickTbas(3)">
            {{ $t('operate.name148') }}
          </div>
        </div>
        <div class="right-content">
          <div class="left-img" v-if="selectIndex === 0 || selectIndex === 1">
            <img v-if="selectIndex === 0 && previewIndex === 1" src="@/assets/app_mian.jpg" alt=""  class="img"/>
            <img v-if="selectIndex === 0 && previewIndex === 2" src="@/assets/app_login.jpg" alt="" class="img" />
            <img v-if="selectIndex === 0 && appConfig.log1 && previewIndex === 1" :src="appConfig.log1" class="show-avatar2" />
            <img v-if="selectIndex === 0 && appConfig.log2 && previewIndex === 2" :src="appConfig.log2" class="show-avatar3" />
            <iframe v-if="selectIndex === 1" :src="appConfig.shopCenterUrl" class="iframe" ></iframe>
          </div>
          <div class="right-setting">
            <div v-if="selectIndex ===0">
              <div class="text1">{{ $t('operate.name149') }}</div>
            <div class="text2">
              {{ $t('operate.name200') }}
            </div>
            <div class="upload-layout2 margin-top10">
                <el-upload class="avatar-uploader2" action  :http-request="(e) => {handleUpLoadFile(3,e)}" :show-file-list="false">
                  <img v-if="appConfig.log1" :src="appConfig.log1" class="avatar2" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button type="primary" @click="previewImg(1)">{{ $t('operate.name150') }}</el-button>
              </div>
              <div class="text2">
              {{ $t('operate.name200') }}
            </div>
            <div class="upload-layout2 margin-top10">
                <el-upload class="avatar-uploader3" action  :http-request="(e) => {handleUpLoadFile(4,e)}" :show-file-list="false">
                  <img v-if="appConfig.log2" :src="appConfig.log2" class="avatar3" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-button type="primary" @click="previewImg(2)">{{ $t('operate.name150') }}</el-button>
              </div>
            </div>
            <div v-if="selectIndex === 1">
              <div class="text1">{{ $t('operate.name146') }}</div>
              <div class="text2">{{ $t('operate.name151') }}<el-input v-model="appConfig.shopCenterUrl" :placeholder="$t('operate.name154')" class="input-shop"></el-input></div>
            </div>
            <div v-if="selectIndex === 2" class="user-notice">
              <div class="left-preview">
                 <div>
                  {{ $t('operate.name152') }}
                 </div>
                 <div v-html="appConfig.noticeToUser">
                 </div>
              </div>
              <div class="right-edit">
                <quill-editor
                class="quill-editor"
                v-model="appConfig.noticeToUser"
                ref="myQuillEditor1"
                :options="editorOption"
                />
              </div>
            </div>
            <div v-if="selectIndex === 3" class="user-notice">
              <div class="left-preview">
                 <div>
                  {{ $t('operate.name153') }}
                 </div>
                 <div v-html="appConfig.privacyPolicy">
                 </div>
              </div>
              <div class="right-edit">
                <quill-editor
                class="quill-editor"
                v-model="appConfig.privacyPolicy"
                ref="myQuillEditor2"
                :options="editorOption"
                />
              </div>
            </div>
          </div>
        </div>
        <el-button type="primary" @click="handlerAppConfigInfo" :loading="loading" style="height:40px;">{{ $t('public.name13') }}</el-button>
      </div>
      <div v-else class="no-data">
        <img src="@/assets/no-data.png"/>
        <div>{{ $t('operate.name201') }}</div>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import {
  getAppConfigure,
  updateAppConfigure
} from '@/api/operate.js'
export default {
  components: {
    quillEditor
  },
  computed: {
    ...mapGetters(['userinfo']),
    editorOption () {
      return {
        placeholder: this.$t('public.name5')
      }
    }
  },
  data() {
    return {
      selectIndex: 0,
      loading: false,
      appConfig: {
        log1: '',
        log2: '',
        shopCenterUrl: '',
        noticeToUser: '',
        privacyPolicy: '',
        id: ''
      },
      previewIndex: 1
    }
  },
  created() {
  },
  mounted() {
    if (this.userinfo.appCode) {
      getAppConfigure({ appCode: this.userinfo.appCode }).then((res) => {
        if (res.code === 200) {
          this.appConfig.log1 = res.data.log1
          this.appConfig.log2 = res.data.log2
          this.appConfig.noticeToUser = res.data.noticeToUser
          this.appConfig.privacyPolicy = res.data.privacyPolicy
          this.appConfig.shopCenterUrl = res.data.shopCenterUrl
          this.appConfig.id = this.userinfo.appId
        }
      }).catch(() => {})
    }
  },
  methods: {
    clickTbas(index) {
      this.selectIndex = index
    },
    previewImg(index) {
      this.previewIndex = index
    },
    handlerAppConfigInfo() {
      this.loading = true
      updateAppConfigure(this.appConfig).then((res) => {
        if (res.code === 200) {
          this.$message({ type: 'success', message: this.$t('operate.name190') })
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.appConfiguration-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .no-data{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 300px);
    div{
      font-size: 24px;
    }
    img{
      width: 500px;
      height: 500px;
    }
  }
  .config-content{
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: calc(100vh - 160px);
    .tabs{
      display: flex;
      width: 202px;
      flex-direction: column;
      .tab-select{
        width: 200px;
        height: 50px;
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgb(245, 245, 245);
        border-left: 4px solid #409eff;
        cursor: pointer;
      }
      .tab-unselect{
        width: 202px;
        height: 50px;
        font-size: 18px;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        border: 1px solid rgb(245, 245, 245);
      }
    }
    .right-content{
      width: calc(100% - 202px);
      height: calc(100vh - 150px);
      display: flex;
      margin-left: 50px;
      overflow: hidden;
      justify-content: space-between;
      .left-img{
        width: 375px;
        height: auto;
        position: relative;
        .img{
          width: 100%;
          height: 100%;
        }
        .iframe{
          width: 100%;
          height: calc(100vh - 160px);
        }
      }
      .right-setting{
        padding-left: 30px;
        width: calc(100% - 375px);
        height: calc(100vh - 190px);
        display: flex;
        flex-direction: column;
        .text1{
          color: #000;
          font-size: 18px;
          font-weight: 600;
        }
        .text2{
          font-size: 16px;
          margin-top: 15px;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .input-shop{
          width: 400px;
        }
      }
    }
  }
  .margin-top10{
    margin-top: 10px;
  }
  .upload-layout2 {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    margin-bottom: 20px;
  }
  .avatar-uploader3 {
  border: 1px dashed #d9d9d9 !important;
  cursor: pointer;
  position: relative;
  width: 200px;
  height: 50px;
  overflow: hidden;
  margin-right: 20px;

  .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: center;
}
}
.avatar-uploader2 {
  border: 1px dashed #d9d9d9 !important;
  cursor: pointer;
  position: relative;
  width: 200px;
  height: 100px;
  overflow: hidden;
  margin-right: 20px;

  .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
}
.avatar2 {
      width: 200px;
      height: 100px;
      object-fit: cover;
    }

    .avatar3 {
      width: 200px;
      height: 50px;
      object-fit: cover;
    }
    .show-avatar2 {
      width: 200px !important;
      height: 100px !important;
      position: absolute;
      left: 50%;
      top: 160px;
      object-fit: cover;
      transform: translate(-50% , 0px);
    }

    .show-avatar3 {
      width: 200px !important;
      height: 50px !important;
      position: absolute;
      left: 50%;
      top: 140px;
      object-fit: cover;
      transform: translate(-50% , 0px);
    }

    .user-notice{
  display: flex;
  width: 100%;
  justify-content: space-between;
  .left-preview{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 375px;
    height: calc(100vh - 190px);
    border-radius: 10px;
    overflow: auto;
    padding: 15px;
    border: 2px solid rgb(245, 245, 245);
  }
  .right-edit{
    width:calc(100% - 375px);
    height: 900px;
    margin-left: 30px;
    .quill-editor{
      width:720px;
      height: calc(100vh - 220px);
    }
  }
}

}
</style>
